import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "750 words a day keeps the insanity away",
  "description": "",
  "published": "2011-05-16T00:00:00.000Z",
  "redirect_from": ["/blog/750-words-a-day-keeps-the-insanity-away/swizec/1703"],
  "categories": "750words, Arts, Uncategorized, Writing, Writing Exercises",
  "hero": "./img/mevv7.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Beginning of May I came across a pretty interesting website, `}<a parentName="p" {...{
        "href": "http://750words.com"
      }}>{`75owords.com`}</a>{`.`}</p>
    <p>{`The general idea of the website is that you write `}<a parentName="p" {...{
        "href": "http://750words.com",
        "title": "750 Words"
      }}>{`750 words`}</a>{` every day. About anything. Unedited. Unhindered. Completely free. Just write about whatever comes to mind in whichever way it decides to come. When you're done you simply tuck it away somewhere never to be seen again.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "808px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/63e377a27640e6039629c7616b260a41/3534c/mevv7.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "95.51569506726457%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'382\\'%20viewBox=\\'0%200%20400%20382\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M66%203c0%201-2%202-5%202-5-1-8%202-5%205h18c1-1%201%200%201%201%200%203%202%204%204%202V5c-1-1-1%200-1%201l-1%203-1-2-1-3-1%203-1%202-1-3c0-4-1-5-2-3h-4m189%200l-5%202h-6l-5-1c-4%200-4%200-4%204l1%203%201-3%201-2c1-1%201%200%201%202l1%203%201-2%201-3%201%203c0%202%200%202%201%201h6l-2-1%201-1c1-1%202%200%202%201l3%202c2%200%202-1%202-4V2l-1%201M7%2019L6%2041c0%2018%200%2021%202%2021%203%202%20187%201%20188%200s2-39%200-42c0-2-9-2-94-2L7%2019m197%200v22l1%2021h189V19l-95-1-95%201M93%2078c-46%207-64%2064-30%2097%2035%2033%2095%207%2095-41%200-34-32-61-65-56m197%201c-18%203-33%2014-40%2029-4%206-7%2017-6%2018a454%20454%200%200052%208c2%200-2%204-18%2018l-20%2019c0%202%2011%2010%2016%2013%2033%2017%2073-3%2081-40%202-12%204-11-28-11l-28-1%2013-53h-22M105%20335v22l1%2021h90v-44h-45l-46%201m99%200v22l1%2021h91v-42l-1-2h-45l-46%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/63e377a27640e6039629c7616b260a41/ca0a1/mevv7.webp 223w", "/static/63e377a27640e6039629c7616b260a41/75680/mevv7.webp 445w", "/static/63e377a27640e6039629c7616b260a41/2b269/mevv7.webp 808w"],
                "sizes": "(max-width: 808px) 100vw, 808px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/63e377a27640e6039629c7616b260a41/e92b6/mevv7.png 223w", "/static/63e377a27640e6039629c7616b260a41/e66bf/mevv7.png 445w", "/static/63e377a27640e6039629c7616b260a41/3534c/mevv7.png 808w"],
                "sizes": "(max-width: 808px) 100vw, 808px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/63e377a27640e6039629c7616b260a41/3534c/mevv7.png",
                "alt": "mevv7",
                "title": "Analysis of today's 750words",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Analysis of today's 750words`}</figcaption>{`
  `}</figure></p>
    <p>{`Why would you do that? Why write sooooo much text so nobody will ever read it.`}</p>
    <p>{`First thing you have to understand is this isn't even all that much text. If you do it in handwriting that's just about three pages and when typing, well hey, anyone who spends a lot of time on the internet is capable of pumping out text like a mad machine. Just count all your tweets, go on.`}</p>
    <p>{`Counted?`}</p>
    <p>{`You can get 27 average `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/English_language",
        "title": "English language"
      }}>{`English`}</a>{` `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Word",
        "title": "Word"
      }}>{`words`}</a>{` into a tweet. But yours probably aren't all that very long so let's say 750 words translates only to about 60 tweets.`}</p>
    <p>{`Personally that's about two or three days of `}<a parentName="p" {...{
        "href": "http://twitter.com",
        "title": "Twitter"
      }}>{`tweeting`}</a>{`. Your mileage may vary.`}</p>
    <p>{`Right, so it isn't a lot of work and if you're at all capable of blabbing on and on about something, or even simply just to write out your train of thought, then writing 750 words shouldn't take more than 20 minutes.`}</p>
    <p>{`But question remains, why the hell would you do it?`}</p>
    <p>{`Turns out it's really really good `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Physical_exercise",
        "title": "Physical exercise"
      }}>{`exercise`}</a>{` for the brain. You know how everybody advises you have a good morning routine that you follow every morning? And that this routine should include some form of exercise to wake you up, get the blood pumping and just generally prime you up for the day much better than caffeine ever could?`}</p>
    <p>{`Now think about where between breakfast, shower and exercise does kickstarting your brain come in?`}</p>
    <p>{`That's right. Writing 750 words!`}</p>
    <p>{`Since I've been doing it daily I've noticed a pretty major effect on my productivity. When I get to work I'm usually already at my productive peak or thereabouts, because I had time to think about anything that's ailing me or causing me problems ... that's out of the way and already processed. When I feel like it's going to be a stressful long day ... the 750words helps me plan it out mentally beforehand and so on.`}</p>
    <p>{`Hell, it's even a good morning-after-party tool to help remember everything that transpired the previous night and make sure I didn't do anything too stupid; since it's generally easier to reconstruct a sequence of events if you try writing it down like a story.`}</p>
    <p>{`Oh and 750words also does one pretty cool thing. It analyzes everything you've written and provides a very plastic view of things that are troubling you. It's a bit rudimentary so it doesn't always get it perfectly (it thought I was concerned about death when I wrote about how awesome `}<a parentName="p" {...{
        "href": "http://www.shutterisland.com/",
        "title": "Shutter Island (film)"
      }}>{`Shutter Island`}</a>{` was) ... hell, this part of hte website is so awesome I'm thinking about making some sort of plugin and always displaying the charts in the footer of this blog.`}</p>
    <p>{`Seriously, go, write 750 words `}<em parentName="p">{`right now`}</em>{`.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.lifehack.org/articles/productivity/kickstart-your-creativity-by-writing-750-words-a-day.html"
        }}>{`Kickstart Your Creativity By Writing 750 Words a Day`}</a>{` (lifehack.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://robinmonks.com/2011/04/02/750-words-100-push-ups-in-10-hours-8-billable-hours-morning-devotions/"
        }}>{`750 words, 100 push-ups in 10 hours, 8 billable hours + morning devotions`}</a>{` (robinmonks.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://doingthewritething.wordpress.com/2011/02/24/great-website-750words-com/"
        }}>{`Great Website: 750words.com!`}</a>{` (doingthewritething.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://inspirationlocation.com/2011/03/06/750-words-freakout-reconsidered/"
        }}>{`750 Words Freakout - Reconsidered`}</a>{` (inspirationlocation.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://ketik06.wordpress.com/2011/03/11/morning-pages/"
        }}>{`Morning Pages`}</a>{` (ketik06.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://awesomestudy.wordpress.com/2011/03/14/ridiculous-competitions-to-boost-your-creativitytime-managementtiredness/"
        }}>{`Ridiculous Competitions to Boost your Creativity/Time Management/Tiredness`}</a>{` (awesomestudy.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://asstochair.wordpress.com/2011/04/20/750-words/"
        }}>{`750 Words.`}</a>{` (asstochair.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=ddd8a961-104b-4400-8693-34c39dde4af0",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      